import { render, staticRenderFns } from "./MaterialDetail.vue?vue&type=template&id=457906c2&"
import script from "./MaterialDetail.vue?vue&type=script&lang=ts&"
export * from "./MaterialDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports